import classNames from 'clsx';
import type { MdComponentIndexProps } from '../type';
import styles from './Card.module.less';

function MarkdownCardGroup(
  props: React.PropsWithChildren<
    {
      cols?: string;
      style?: React.CSSProperties;
      className?: string;
    } & MdComponentIndexProps
  >,
) {
  return (
    <div
      className={classNames(styles.cardGroup, props.className)}
      data-markdown-component="x-card-group"
      style={{
        ...props.style,
        gridTemplateColumns: `repeat(${props.cols || '2'}, minmax(0, 1fr))`,
      }}
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      {props.children}
    </div>
  );
}

MarkdownCardGroup.attributes = ['cols', 'style', 'className'];

export { MarkdownCardGroup };
